import { lazy } from 'react';

const FuturePathModal = lazy(() => import('./FuturePathModal'));
const CareerGoalModal = lazy(() => import('./CareerGoalModal'));
const CollegeGoalModal = lazy(() => import('./CollegeGoalModal'));
const MajorTrainingGoalModal = lazy(() => import('./MajorTrainingGoalModal'));
const GoalCompleteModal = lazy(() => import('./GoalCompleteModal'));
const GoalMarkedCompleteModal = lazy(() => import('./GoalMarkedCompleteModal'));
const WhatIsSmartGoalModal = lazy(() => import('./WhatIsSmartGoalModal'));
const GoalCreationMethodModal = lazy(() => import('./GoalCreationMethodModal'));
const PredefinedGoalsModal = lazy(() => import('./PredefinedGoalsModal'));

export default {
  FUTURE_PATH_MODAL: FuturePathModal,
  CAREER_GOAL_MODAL: CareerGoalModal,
  COLLEGE_GOAL_MODAL: CollegeGoalModal,
  MAJOR_TRAINING_GOAL_MODAL: MajorTrainingGoalModal,
  GOAL_COMPLETE_MODAL: GoalCompleteModal,
  GOAL_MARKED_COMPLETE_MODAL: GoalMarkedCompleteModal,
  WHAT_IS_SMART_GOAL_MODAL: WhatIsSmartGoalModal,
  GOAL_CREATION_METHOD_MODAL: GoalCreationMethodModal,
  PREDEFINED_GOALS_MODAL: PredefinedGoalsModal,
};
